import { jsx } from "react/jsx-runtime";
import Check from "@mui/icons-material/Check";
import { useCallback } from "react";
import { NO_COLOR } from "../../constants.js";
import { Tooltip } from "../Tooltip.js";
import { Chip } from "./components/Chip.js";
import { NoColorChip } from "./components/NoColorChip.js";
import { NoColorIcon } from "./components/NoColorIcon.js";
import { useContrastColor } from "./hooks/useContrastColor.js";
import { usePrettifyLabel } from "./hooks/usePrettifyLabel.js";
function Swatch(props) {
  const { onSelect, color, label, swatchSize, localeText, ...rest } = props;
  const onClick = useCallback(
    (e) => {
      onSelect(e, color);
    },
    [onSelect, color]
  );
  const contrastColor = useContrastColor(color);
  const prettyLabel = usePrettifyLabel(color, localeText, label);
  const ChipComponent = color === NO_COLOR ? NoColorChip : Chip;
  const Icon = color === NO_COLOR ? NoColorIcon : Check;
  return /* @__PURE__ */ jsx(Tooltip, { enterDelay: 500, placement: "bottom", title: prettyLabel, children: /* @__PURE__ */ jsx(
    ChipComponent,
    {
      bgcolor: color,
      contrastColor,
      "data-color": color,
      "data-testid": "TidalColorPickerSwatch",
      onClick,
      size: swatchSize,
      ...rest,
      children: /* @__PURE__ */ jsx(Icon, {})
    }
  ) });
}
export {
  Swatch
};
//# sourceMappingURL=Swatch.js.map
